import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// DELETE /api/settings/roles/:id
//
// Replaces revalidatePath("/admin/settings/roles") + redirect(
// "/admin/settings/roles") from /app/admin/settings/roles/_actions.ts.
// redirect: SPA caller navigates to /admin/settings/roles after success.
// Server returns 409 with code "role_has_users" or 403 "system_role_protected"
// for the legacy guards.
export function useDeleteRole() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, string>({
    mutationFn: (id) =>
      apiFetch<{ ok: true }>(`/settings/roles/${id}`, {
        method: "DELETE",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.settings.roles() });
      queryClient.invalidateQueries({ queryKey: queryKeys.settings.audit() });
    },
    onError: (err) => {
      if (err.code === "system_role_protected") {
        toast.error("System roles cannot be deleted.");
        return;
      }
      if (err.code === "role_has_users") {
        toast.error("Reassign users off this role before deleting.");
        return;
      }
      toast.error(err.message ?? "Failed to delete role");
    },
  });
}
